import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import SummaryDetailsLineItem from './SummaryDetailsLineItem';
import { SUMMARY_DETAILS_DISPLAY_CONFIG } from '../../constants/defaultSettings';

const getItemizations = ({ itemizationsByType, selectedType }) => {
  const mainItemization = itemizationsByType[selectedType];
  if (!isEmpty(mainItemization)) {
    return mainItemization;
  }

  // If none match go with first by default for estimates purposes
  const itemizationMethods = Object.keys(itemizationsByType);
  if (itemizationMethods.length > 0) {
    return itemizationsByType[itemizationMethods[0]];
  }

  return {};
};

export const mapStateToProps = ({
  language = {},
  page: { productType } = {},
  returnsSettings: {
    [productType]: {
      refunds: {
        summary_details_display_config: displayConfig = SUMMARY_DETAILS_DISPLAY_CONFIG,
      } = {},
    } = {},
  } = {},
  refunds: { selectedType, estimate: { methods = [] } = {}, itemizationsByType = {} } = {},
  returnMethods: { selectedMethodKey } = {},
}) => ({
  language,
  displayConfig,
  itemizations: getItemizations({ itemizationsByType, selectedType }),
  refundData: methods.find((method) => method.type === selectedType),
  returnMethod: selectedMethodKey,
});

const SummaryDetails = ({ displayConfig, refundData, language, itemizations, returnMethod }) => {
  if (isEmpty(itemizations)) return null;
  const { refund_disclaimer: { value: refundDisclaimer } = {} } = itemizations;
  return (
    <div className="summary-fees-container" role="dialog" aria-label="Fee Summary">
      {displayConfig.map((config) => {
        const item = itemizations[config.key];
        if (!item) return null;
        return (
          <SummaryDetailsLineItem
            key={config.key}
            language={language}
            nameToken={refundData.name_token}
            config={config}
            item={item}
            returnMethod={returnMethod}
          />
        );
      })}
      {refundDisclaimer && (
        <p style={{ padding: '10px 5px' }} className="return-summary-refund-disclaimer">
          {refundDisclaimer}
        </p>
      )}
    </div>
  );
};

SummaryDetails.defaultProps = {
  displayConfig: SUMMARY_DETAILS_DISPLAY_CONFIG,
  refundData: {},
};

SummaryDetails.propTypes = {
  language: PropTypes.object.isRequired,
  itemizations: PropTypes.object.isRequired,
  returnMethod: PropTypes.string.isRequired,
  refundData: PropTypes.object,
  displayConfig: PropTypes.array,
};

export default connect(mapStateToProps)(SummaryDetails);
